import { useEffect, useState } from 'react';
import { API_ORIGIN } from '@cld/session-service';
import { UnicornApi } from '@cld/unicorn-api';

const API_URL = `${API_ORIGIN}/console/api/v1`;

// FIXME: won't fetch on local environment because we do not have access to auth cookie
// istanbul ignore next
export const useAccountData = ({ customerExternalId, unicornApi }: { customerExternalId?: string; unicornApi?: UnicornApi }) => {
  const [accountData, setAccountData] = useState<
    { createdAt: string; externalId: string; planName: string; companyName: string | undefined; name: string | undefined } | undefined
  >(undefined);

  useEffect(() => {
    if (unicornApi) {
      setAccountData({
        companyName: unicornApi.data.account.companyName,
        name: unicornApi.data.account.name,
        planName: unicornApi.data.plan.name,
        createdAt: unicornApi.data.account.__MIGRATION_createdAt,
        externalId: unicornApi.data.account.externalId,
      });
      return;
    }

    const commonOptions: RequestInit = {
      credentials: 'include',
      headers: {
        ...(customerExternalId ? { 'X-Cld-Customer-External-Id': customerExternalId } : {}),
      },
    };
    const accountRequest = fetch(`${API_URL}/account`, commonOptions);
    const planRequest = fetch(`${API_URL}/account/plan`, commonOptions);

    void Promise.all([accountRequest, planRequest])
      .then(([accountResponse, planResponse]) => Promise.all([accountResponse.json(), planResponse.json()]))
      .then(([account, plan]) => {
        const castAccount = account as { created_at?: string; external_id?: string; name?: string; company_name?: string } | undefined;
        const castPlan = plan as { name?: string } | undefined;

        if (castAccount?.created_at && castAccount?.external_id && castPlan?.name) {
          setAccountData({
            createdAt: castAccount.created_at,
            externalId: castAccount.external_id,
            planName: castPlan.name,
            companyName: castAccount?.company_name,
            name: castAccount.name,
          });
        }
      })
      .catch((errors) => console.debug('[AppWrapper] Could not fetch account and plan for split setup', errors));
  }, [customerExternalId, unicornApi]);

  return accountData;
};
